import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-buttons',
  templateUrl: './buttons.component.html',
  styleUrl: './buttons.component.scss',
  standalone: false
})
export class ButtonsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
